import { render, staticRenderFns } from "./BasePhoneInput.vue?vue&type=template&id=706fcf5c&scoped=true&"
import script from "./BasePhoneInput.vue?vue&type=script&lang=js&"
export * from "./BasePhoneInput.vue?vue&type=script&lang=js&"
import style0 from "./BasePhoneInput.vue?vue&type=style&index=0&id=706fcf5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706fcf5c",
  null
  
)

export default component.exports